import {interopDefault} from '@/utils/helpers'

const TransfersPage = () => interopDefault(import('@/pages/transfers/TransfersPage'))
const TransferPage = () => interopDefault(import('@/pages/transfers/TransferPage'))
const TransferBookingPage = () => interopDefault(import('@/pages/transfers/TransferBookingPage'))
const TransferConfirmationPage = () => interopDefault(import('@/pages/transfers/TransferConfirmationPage'))
const TransfersComparisonPage = () => interopDefault(import('@/pages/transfers/TransfersComparisonPage'))

export default [
    {
        path: '/search/transfers',
        component: TransfersPage,
        name: 'transfers',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/transfer',
        component: TransferPage,
        name: 'transfer',
        beforeEnter: (to, from, next) => {
            if (!to.query.name) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.name,
        },
    },
    {
        path: '/transfers/compare',
        component: TransfersComparisonPage,
        name: 'transfersComparison',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/transfers/booking',
        component: TransferBookingPage,
        name: 'transferBooking',
        beforeEnter: (to, from, next) => {
            if (!to.query.offerKey) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/transfers/confirmation',
        component: TransferConfirmationPage,
        name: 'transferConfirmation',
        beforeEnter: (to, from, next) => {
            if (!to.query.orderId) {
                next({name: 'home'})
            }
            next()
        },
        meta: {
            unwrapped: true,
        },
    },
]
